import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch, useRouteMatch, useHistory } from 'react-router-dom';
import CardCreation from '../../components/CreateCards/CardCreation';
import CardsList from '../../components/CreateCards/CardsList';
import TopUpCard from '../../components/CreateCards/TopUpCard';
import DetailCardPage from '../../components/CreateCards/DetailCardPage';
import { useLocation } from 'react-router-dom';
import AxioInstance from '../../axios/AxiosConfig';
import { AuthContext } from '../../context/AuthContext';
import { CircularProgress } from '@material-ui/core';
const CardCreationContainer = (props) => {
    let { path, url } = useRouteMatch();
    const history = useHistory();
    const [showCardCreation, setShowCardCreation] = useState(true);
    const { getAuthenticatedHeaders } = useContext(AuthContext);
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchCards = async () => {
            try {
                const response = await AxioInstance.post('/api/get_card', {
                    headers: await getAuthenticatedHeaders(),
                });
                console.log("🚀 ~ fetchCards ~ response:", response)
                if (response.data?.status === 200 && response.data?.data?.result?.length > 0) {
                    setError(null)
                    const cardsList = response.data?.data?.result

                    setCards(cardsList);

                    history.replace(`${path}/lista`);
                    setShowCardCreation(false);

                } else {
                    console.log("Holaaa",)
                    history.replace(`${path}/crear`);
                    setShowCardCreation(true);
                    setError('Ups! Ha ocurrido un error al cargar las tarjetas');
                }
            } catch (e) {
                console.log("🚀 ~ fetchCards ~ e:", e)
                setError(e);
            } finally {
                setLoading(false);
            }
        };
        fetchCards();
    }, []);
    return (


        <Switch >
            <Route exact path={path}>
                <div className="flex justify-center items-center">
                    <CircularProgress size={90} />
                </div>
            </Route>
            <Route path={`${path}/crear`} component={CardCreation} />
            <Route path={`${path}/lista`} component={(props) => <CardsList {...props} cards={cards} />} />
            <Route path={`${path}/recargar`} component={TopUpCard} />
            <Route path={`${path}/detalle`} component={DetailCardPage} />
            <Redirect from={path} to={showCardCreation ? `${path}/crear` : `${path}/lista`} />

            {loading ? <p>Cargando...</p> :
                <>
                    {/*                    
 */}                </>
            }

        </Switch>
    );
};

export default CardCreationContainer;
const NoMatch = () => {

    let location = useLocation();
    return (
        <div className="flex md:flex-row flex-wrap p-4">
            <div className="w-full bg-white p-4 text-center ">
                No encontramos nada para <code>{location.pathname}</code>
            </div>
        </div>
    );
}
